module.exports = __webpack_public_path__ + "img/arrow-90deg-up.33064467.svg";